export default __webpack_public_path__ + "static/media/shard-culture-inactive.01dd1f59.jpg";